import {   basicProps, suggestedInventoryExpenseSheetProps, recipeProps } from './properties'

export const setRecipeList = (state, payload) => {
    state.list = payload
    state.list.push(JSON.parse(JSON.stringify(basicProps)))

    state.list.forEach(element => {
        if(element.suggested_inventory_expense_sheet.length === 0) {
            element.suggested_inventory_expense_sheet = [JSON.parse(JSON.stringify(suggestedInventoryExpenseSheetProps))]
        } else {
            element.suggested_inventory_expense_sheet.push(JSON.parse(JSON.stringify(suggestedInventoryExpenseSheetProps)))
        }

        if(element.recipe_list == null) {
            element.recipe_list = []
            element.recipe_list = [JSON.parse(JSON.stringify(recipeProps))]
        } else if(element.recipe_list.length === 0) {
            element.recipe_list = [JSON.parse(JSON.stringify(recipeProps))]
        } else {
            element.recipe_list.push(JSON.parse(JSON.stringify(recipeProps)))
        }

        let indexNum = 0
        element.recipe_list.forEach(element1 => {
            element1.key = indexNum
            indexNum ++
        })

    })
}

export const alterRecipeCost = (state, payload) => {

    let mainList = state.list

    mainList.forEach(recipe => {
        let index = recipe.suggested_inventory_expense_sheet.findIndex(t => t.inventory_item_id == payload.id)

        if(index >= 0) {

            let indexProp = recipe.suggested_inventory_expense_sheet[index]
            indexProp.cost_per_unit = payload.cost
            indexProp.presentation = payload.presentation

            indexProp.recipe_cost 
                = ((indexProp.cost_per_unit/indexProp.presentation)*indexProp.required_quantity)

            indexProp.inventory_unit_cost = (indexProp.recipe_cost/recipe.portion_qty)
            
            recipe.unit_cost = parseFloat(recipe.suggested_inventory_expense_sheet.reduce((sum, option) => {
                return !isNaN(option.inventory_unit_cost) ? sum + (option.inventory_unit_cost) : sum+0;}, 0))
            
            //console.log(recipe.unit_cost)
            recipe.total_cost = parseFloat(recipe.quantity_per_guest) * parseFloat(recipe.unit_cost)
            
            recipe.updated = 1
        }

    })
    state.list = mainList
    //console.log(JSON.stringify(state.list))
}

export const setRecipeItem = (state, payload) => {
    state.list[payload].recipe_list.push(JSON.parse(JSON.stringify(recipeProps)))

    let indexNum = 0
    state.list[payload].recipe_list.forEach(element => {
        element.key = indexNum
        indexNum ++
    })
    
}



// WEBPACK FOOTER //
// ./src/store/modules/recipe/mutations.js